import { useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { updateOrganizationSetting as updateOrganizationSettingService } from '../../../services/organization/OrganizationService';

interface Values {
  isLoading: boolean;
  updateOrganizationSetting: (organizationId: string, settings: any) => Promise<number>;
}

const useUpdateOrganizationSetting = (): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const updateOrganizationSetting = async (organizationId: string, setting: any): Promise<number> => {
    try {
      setIsLoading(true);

      const result = await updateOrganizationSettingService(organizationId, setting);
      setIsLoading(false);
      return result.data;
    } catch (error) {
      handleError(error);
      setIsLoading(false);
      return 0;
    }
  };

  return { updateOrganizationSetting, isLoading };
};

export default useUpdateOrganizationSetting;
